export const GET_COURSES = 'dashboard/get_courses';